var map = {
	"./1.jpg": 9508,
	"./2.jpg": 9330,
	"./3.jpg": 2042,
	"./4.jpg": 2980,
	"./5.jpg": 1313,
	"./6.jpg": 4978,
	"./7.jpg": 8854,
	"./8.jpg": 6993,
	"./9.jpg": 4623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2077;